import { CATEGORY_HAUNT } from "@/components/game-categories/constants";
import { hasCategory } from "@/components/game-categories/helpers";
import { cloudinaryImageUrl } from "@/helpers/cloudinary-url";
import { gameUrl } from "@/helpers/games";

import { type GameType, ImageTypeEnum } from "../types";

const HAUNT_WORD_REGEX = /haunt\w*/i;

export function getGameMetaProps(game: GameType) {
  const description = `Visit the ${game.name} attraction in ${game.location.locality.locality}, ${game.location.locality.region}. Discover ratings, reviews, and other important details about this immersive adventure.`;

  const img = (game.gameimageSet || []).find(
    (i) => i.imageType === ImageTypeEnum.IMAGE
  );
  const image = img
    ? cloudinaryImageUrl(img.imageId)
    : `${process.env.APP_URL}/images/share.jpg`;

  const isHaunt =
    !!game.primaryCategory && hasCategory(game.primaryCategory, CATEGORY_HAUNT);
  const pageTitleParts: string[] = [game.name];

  if (
    game.kind === "RER" &&
    !game.name.toLowerCase().includes("escape") &&
    !isHaunt
  ) {
    pageTitleParts.push("Escape Room");
  }

  // Add Haunted Attraction to the title if "*haunt*" isn't in the game title
  if (isHaunt && !HAUNT_WORD_REGEX.test(game.name)) {
    pageTitleParts.push("Haunted Attraction");
  }

  pageTitleParts.push("|");
  pageTitleParts.push(game.location.displayName || game.location.company.name);

  const title = pageTitleParts.join(" ");

  const url = process.env.APP_URL + gameUrl(game);

  return { description, image, title, url };
}
